import { Sparkle } from "lucide-react";
import { useLang } from "@/context";

export const Marquee = () => {
    const { t } = useLang();
    return (
        <div data-testid="editorial-marquee" className="bg-[#2A0505] text-[#F3E6DE] overflow-hidden py-4 select-none border-y border-[#C9A24B]/20">
            <div className="marquee-track flex w-max">
                {[0, 1].map((copy) => (
                    <div key={copy} className="flex items-center shrink-0" aria-hidden={copy === 1}>
                        {t.marquee.map((item, i) => (
                            <span key={i} className="flex items-center">
                                <span className="font-display italic text-lg md:text-2xl px-8 whitespace-nowrap">{item}</span>
                                <Sparkle className="w-3.5 h-3.5 text-[#C9A24B] shrink-0" />
                            </span>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
};
